<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage"/>
      </div>
      <input-search placeholder="姓名" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" @changePagination="changePagination" :operationArr="operationArr" />

     <el-dialog :title="flag?'修改黑名单':'添加黑名单'" :visible.sync="showTip" width="792px">
      <div class="form-line">
            <div class="textBox">
              <span class="line-text">姓名：</span>
            </div>
              <el-input v-model="personList.personName" size="small" style="width: 280px"/>
          </div>
      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">附件：</span>
        </div>
      <input id="upload" name="file" accept="image/*" type="file"
             @change="upData" style="display: none;" />
      <a @click="upImg" class="photoBox" style="position:relative">
        <p class="add" v-if="!personList.picUrl">✚</p>
        <img :src="personList.picUrl" id="peopleImg" class="img" v-if="personList.picUrl" />
      </a>
      </div> -->


    <div class="form-line">
      <div class="textBox">
        <span class="line-text">照片：</span>
      </div>
      <!--<upload-img-list @getImgList="getImgList"  />-->
      <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
             @change="upData2" style="display: none" />
      <div>
        <a class="newly2" @click="upImg2" v-if="!personList.picUrl">
          <span><i class="el-icon-plus"></i></span>
          <span>点击上传</span>
        </a>
        <a class="upload2" @click="upImg2" v-if="personList.picUrl">
          <img :src="personList.picUrl" id="packBg" />
          <b>重新上传</b>
        </a>
      </div>
    </div>


      <div class="form-line">
            <div class="textBox">
              <span class="line-text">备注：</span>
            </div>
              <el-input v-model="personList.memo" size="small" style="width: 280px"/>
          </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTip = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TextTitle from "../../../components/Text/TextTitle";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FaceRecognition";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    TextTitle,
    Breadcrumb
  },
  name: "face-database-authorization",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "人脸库管理"
        }
      ],
      mainTitle: "",
      subheading: "",
      addController: "white-list-vehicles-add",
      exportUrl: "",
      uploadUrl: "",
      tableHead: [
        {
          prop: "personName",
          label: "姓名"
        },
        {
          prop: "picUrl",
          label: "照片",
          isPreviewPic: true
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      total: 0,
      total2: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        isWhite: "1",
        searchKey: ""
      },
      operationArr: ["modify", "delete"],
      showTip: false,
      requestBody: {
        pageNum: 1,
        pageSize: 10,
        searchKey: "",
        hasPhoto: 1
      },
      authPersonData: [],
      wantPersonList: [],
      personList: {
        picUrl: ""
      },
      currentCode: "",
      formData: {},
      formDataPart: {},
      flag: true
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importCarWhiteBlack;
    // this.exportUrl = `${api.exportAuthority}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    this.currentCode = this.$route.params.id;
    this.getFaceDBByCode();
    this.getPage();
    // this.getBasicPersonPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportFaceAuthorize}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    // 获取分页
    getPage() {
      let reqData = this.requestData;
      reqData.faceCode = this.currentCode;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getFaceAuthorizePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.picStatus == "0") {
              v.picStatusText = "成功";
            } else {
              v.picStatusText = "失败";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    goToModifyPage(code) {
      this.flag = true;
      this.formData = this.formDataPart;
      this.tableData.map(v => {
        if (v.code == code) {
          this.personList = v;
        }
      });
      this.showTip = true;
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteFaceAuthorizeByCodes, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.flag = false;
      this.personList = { picUrl: "" };
      this.formData = this.formDataPart;
      this.showTip = true;
    },
    toAuthorize() {},
    cancelAthority() {
      this.showTip = false;
    },
    handleSelectionChange(val) {
      let adsArr = [];
      val.map(v => {
        adsArr.push(v.code);
      });
      this.adsStr = adsArr.join(",");
    },
    handleCurrentChange(val) {
      this.requestBody.pageNum = val;
      this.getBasicPersonPage();
    },
    // 选择人员
    selectPerson(selection, row) {
      selection.map(select => {
        select.personCode = select.code;
        select.personName = select.name;
        let hasPerson = false;
        this.wantPersonList.map(want => {
          if (want.code === select.code) {
            hasPerson = true;
          }
        });
        if (!hasPerson) {
          this.wantPersonList.push(select);
        }
        this.formData.personList = this.wantPersonList;
      });
    },
    getBasicPersonPage() {
      this.$axios.post(api.getBasicPersonPage, this.requestBody).then(res => {
        this.total2 = res.data.total;
        this.authPersonData = res.data.data.list;
        this.showTip = true;
      });
    },
    getFaceDBByCode() {
      this.$axios
        .get(`${api.getFaceDBByCode}/${this.currentCode}`)
        .then(res => {
          let data = res.data.data;
          data.picUrl = "";
          data.faceCode = data.code;
          this.formDataPart = data;
          this.mainTitle = res.data.data.type;
        })
        .catch(errorHandler("获取详情失败"));
    },

    upData() {
      const that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("upload").files[0];
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function(oFRevent) {
        const src = oFRevent.target.result;
        $("#peopleImg").attr("src", src);
        that.personList.picUrl = src;
      };
    },
    upImg() {
      $("#upload")
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on("change", function() {
          const objUrl = getObjectURL(this.files[0]); // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            $("#peopleImg").attr("src", objUrl); // 将图片路径存入src中，显示出图片
            window.sessionStorage.setItem("img", objUrl);
          }
        });
    },
    confirm() {
      this.formData.personList = [];
      this.formData.personList.push(this.personList);
      if (this.flag) {
        this.$axios
          .post(api.FaceAuthorizeModify, this.formData)
          .then(res => {
            nSuccess("修改成功");
            this.showTip = false;
            this.personList = {
              personName: "",
              picUrl: "",
              memo: ""
            };
            this.getPage();
          })
          .catch(errorHandler("修改人员失败"));
      } else {
        this.$axios
          .post(api.FaceAuthorizeAdd, this.formData)
          .then(res => {
            nSuccess("添加成功");
            this.showTip = false;
            this.personList = {
              personName: "",
              picUrl: "",
              memo: ""
            };
            this.getPage();
          })
          .catch(errorHandler("添加人员失败"));
      }
    },

    upData2: function() {
      let that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("uploadGuidedGraph").files[0];
      if (file.size > 1024 * 1024) {
        nError("上传图片不能大于1M");
        return false;
      }
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function(oFRevent) {
        const src = oFRevent.target.result;
        that.pictureBase64 = src;
        that.uploadPicture();
      };
    },
    upImg2: function() {
      document.getElementById("#uploadBackgroundImg");
      $("#uploadGuidedGraph")
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on("change", function() {
          // const objUrl = getObjectURL(this.files[0])
          // if (objUrl) {
          //   $('#pic2').attr('src', objUrl)
          // }
        });
    },
    // 上传图片
    uploadPicture() {
      this.$axios
        .post(api.uploadImg, {
          picData: this.pictureBase64
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.personList.picUrl = res.data.data;
          } else {
            // 提示信息，需引入Message
            nError("图片上传失败");
          }
        })
        .catch(errorHandler("图片上传失败"));
    },

    // 上传图片
    uploadImg() {
      if (this.base64List.length < 0) {
        nError("请选择图片");
        return false;
      }
      this.$axios
        .post(api.commonUploadImg, {
          picData: this.base64List[0].personImageStr,
          compressedSize: 2048
        })
        .then(res => {
          if (res.data.retCode === 1) {
            // this.content += `<img src="${res.data.data}">`
            // console.log(this.content)
            let quill = this.$refs.QuillEditor.quill;

            let length = quill.selection.savedRange.index;

            quill.insertEmbed(length, "image", res.data.data);

            quill.setSelection(length + 1);
            this.chooseImageDialogVisible = false;
            this.imageList = [];
            this.base64List = [];
          } else {
            // 提示信息，需引入Message
            nError("图片插入失败");
          }
        })
        .catch(errorHandler("图片插入失败"));
    }
  }
};
function getObjectURL(file) {
  let url = null;
  if (window.createObjectURL !== undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL !== undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL !== undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>

<style lang="less" scoped>
.photoBox {
  width: 120px;
  height: 160px;
  border: 1px dashed #dcdfe6;
  border-radius: 5px;
}
.add {
  font-size: 36px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img {
  width: 120px;
  height: 160px;
}
</style>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 80px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 120px;
  height: 160px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  border-radius: 5px;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 50px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 30px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 120px;
  height: 160px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  border-radius: 5px;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0.7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/FaceDatabaseManagement/FaceDatabaseAuthorizationBlack.vue